import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { EjendomsfaktorDefinition } from "@e-forsyning/common/ejendomsfaktor";

import { OpretKomponentEventArgs } from "./komponenter/komponent-gruppe/komponent-gruppe.component";
import { KomponentType } from "./komponenter/model/komponent-type.model";

@Component({
    selector: "arbejdsgang",
    templateUrl: "./arbejdsgang.component.html",
    styleUrls: ["./arbejdsgang.component.scss"]
})
export class ArbejdsgangComponent {
    @Input() public formGroup: UntypedFormGroup;
    @Input() public komponentTyper: KomponentType[];
    @Input() public ejendomsfaktorDefinitioner: EjendomsfaktorDefinition[];

    @Output() public opretKomponent = new EventEmitter<OpretKomponentEventArgs>();
}
